import { Col, Input, Row } from "reactstrap"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { withRouter } from "react-router-dom"
import { SaveButton } from "components/Buttons"
import { connect } from "react-redux"
import {
  createCategory,
  deleteCategory,
  editCategory,
  getCategories,
  hideCategoryErrorModal,
  hideDeleteCategoryModal,
  hideEditCategoryModal,
  openDeleteCategoryModal,
  openEditCategoryModal,
  updateCategoryOrder,
} from "store/actions"
import { LoadingIndicator } from "components/LoadingIndicator"
import Table from "components/Table"
import categoriesListColumns from "./categoriesListColumns"
import ReactDragListView from "react-drag-listview/lib/index.js"
import ModalComponent from "components/Modals"
import EditCategoryModal from "./editCategoryModal"
import DeleteCategoryModal from "./deleteCategoryModal"
import ErrorMessageModal from "./errorMessageModal"

const Categories = ({
  categories,
  getCategories,
  updateCategoryOrder,
  vendorId,
  isEditCategoryModalOpen,
  hideEditCategoryModal,
  openEditCategoryModal,
  editCategory,
  isDeleteCategoryModalOpen,
  openDeleteCategoryModal,
  hideDeleteCategoryModal,
  deleteCategory,
  createCategory,
  hideCategoryErrorModal,
  isCategoryErrorModalOpen,
  history,
  loading,
  error,
}) => {
  const [searchValue, setSearchValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [newCategoryValue, setNewCategoryValue] = useState("")
  const [defaultOrder, setDefaultOrder] = useState({
    o: "oreder",
    od: "asc",
  })

  useEffect(() => {
    getCategories({ type: 1 })
  }, [])

  const handleSearch = () => {
    if (searchValue.trim().length) {
      getCategories({
        type: 1,
        search: searchValue,
      })
      setShowResetButton(true)
    }
  }

  const handleSort = option => {
    setDefaultOrder(option)
  }

  const handleResetSearch = () => {
    getCategories({
      type: 1,
    })
    setSearchValue("")
    setShowResetButton(false)
  }
  const [selectedCategory, setSelectedCategory] = useState()
  const openEditModal = category => {
    openEditCategoryModal()
    setSelectedCategory(category)
  }

  const openDeleteModal = category => {
    openDeleteCategoryModal()
    setSelectedCategory(category)
  }

  const handleDelete = () => {
    deleteCategory({
      categoryId: selectedCategory.id,
      callback: () => {
        getCategories({
          type: 1,
          ...(searchValue.trim().length ? { search: searchValue } : {}),
        })
      },
    })
  }

  const handleAddNewCategory = () => {
    if (newCategoryValue.trim().length) {
      createCategory({
        values: {
          vendor_id: parseInt(vendorId),
          name: newCategoryValue,
          type: 1,
        },
        callback: () => {
          getCategories({
            type: 1,
            ...(searchValue.trim().length ? { search: searchValue } : {}),
          })
        },
      })
      setNewCategoryValue("")
    }
  }

  const actions = [
    {
      name: "Edit",
      onClick: openEditModal,
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: openDeleteModal,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const onDragEnd = (fromIndex, toIndex) => {
    const modifiedData = [...categories].sort((a, b) => a.order - b.order)
    const item = modifiedData.splice(fromIndex, 1)[0]
    modifiedData.splice(toIndex, 0, item)
    const data = modifiedData
      .map((category, position) => {
        if (
          modifiedData[position].id !==
            categories.sort((a, b) => a.order - b.order)[position].id ||
          modifiedData[position].order === 0
        ) {
          return {
            vendor_id: category?.vendor_id,
            name: category?.name,
            type: category?.type,
            inventory: category?.inventory || 0,
            business_unit_id: category?.business_unit_id,
            id: category.id,
            order: position + 1,
          }
        } else {
          return null
        }
      })
      .filter(category => category)
    data.forEach(category => {
      updateCategoryOrder({
        ...category,
        delete_file: 0,
        delete_banner: 0,
      })
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Categories" />
        <Container fluid>
          <BreadcrumbTitle
            title="Categories"
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Categories",
              },
            ]}
          />
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => history.goBack()}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="mt-1">
              <h6>Create categories to assign experiences to categories.</h6>
            </Col>
          </Row>
          <Row>
            <Col className="mt-2" sm={6} md={5} xl={3}>
              <Input
                value={searchValue}
                onChange={event => {
                  setSearchValue(event.target.value)
                }}
                placeholder="Search"
              />
            </Col>
            <Col xs="auto" className="my-1">
              <SaveButton
                type="button"
                content="Search"
                onClick={handleSearch}
              />
            </Col>
            {showResetButton && (
              <Col xs="auto" className="my-1">
                <SaveButton
                  type="button"
                  content="Reset"
                  color="light"
                  onClick={handleResetSearch}
                />
              </Col>
            )}
          </Row>
          <Row className="mt-2">
            <Col sm={6} md={5} xl={3}>
              <Input
                value={newCategoryValue}
                onChange={event => {
                  setNewCategoryValue(event.target.value)
                }}
                placeholder="Enter new category"
                onKeyPress={event => {
                  if (event?.key === "Enter") {
                    handleAddNewCategory()
                  }
                }}
              />
              
            </Col>
            <Col xs="auto" className="my-1">
              <SaveButton
                type="button"
                content="Add"
                onClick={handleAddNewCategory}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              {false ? (
                <LoadingIndicator />
              ) : defaultOrder.o === "name" ? (
                <Table
                  data={categories}
                  sort={{
                    dataField: defaultOrder.o,
                    order: defaultOrder.od,
                  }}
                  columns={categoriesListColumns(handleSort)}
                  actions={actions}
                />
              ) : (
                <ReactDragListView
                  nodeSelector="tr"
                  handleSelecto="tr"
                  onDragEnd={(fromIndex, toIndex) =>
                    onDragEnd(fromIndex, toIndex)
                  }
                >
                  <Table
                    data={categories.sort((a, b) => a.order - b.order)}
                    columns={categoriesListColumns(handleSort)}
                    actions={actions}
                  />
                </ReactDragListView>
              )}
            </Col>
          </Row>
        </Container>
      </div>
      <ModalComponent
        open={isEditCategoryModalOpen}
        onClose={hideEditCategoryModal}
        title={`Edit category - "${selectedCategory?.name}"`}
      >
        <EditCategoryModal selectedCategory={selectedCategory} />
      </ModalComponent>
      <ModalComponent
        open={isDeleteCategoryModalOpen}
        onClose={hideDeleteCategoryModal}
        title={`Delete category - "${selectedCategory?.name}"`}
      >
        <DeleteCategoryModal
          hideModalHandler={hideDeleteCategoryModal}
          handleDelete={handleDelete}
        />
      </ModalComponent>
      <ModalComponent
        open={isCategoryErrorModalOpen}
        onClose={hideCategoryErrorModal}
      >
        <ErrorMessageModal
          onClose={hideCategoryErrorModal}
          message={error?.data?.error?.name}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  categories: state.Categories.categories,
  showLoadingIndicator: state.experiences.showLoadingIndicator,
  vendorId: state.Login.vendorId,
  isEditCategoryModalOpen: state.Categories.isEditCategoryModalOpen,
  isDeleteCategoryModalOpen: state.Categories.isDeleteCategoryModalOpen,
  isCategoryErrorModalOpen: state.Categories.isCategoryErrorModalOpen,
  loading: state.Categories.loading,
  error: state.Categories.error,
})

const mapDispatchToProps = dispatch => ({
  getCategories: values => dispatch(getCategories(values)),
  updateCategoryOrder: values => dispatch(updateCategoryOrder(values)),
  hideEditCategoryModal: () => dispatch(hideEditCategoryModal()),
  openEditCategoryModal: () => dispatch(openEditCategoryModal()),
  openDeleteCategoryModal: () => dispatch(openDeleteCategoryModal()),
  hideDeleteCategoryModal: () => dispatch(hideDeleteCategoryModal()),
  hideCategoryErrorModal: () => dispatch(hideCategoryErrorModal()),
  deleteCategory: values => dispatch(deleteCategory(values)),
  createCategory: values => dispatch(createCategory(values)),
  editCategory: (categoryId, data) => dispatch(editCategory(categoryId, data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Categories))
